import React from "react";
import PinScreenLayout from "../../components/PinScreenLayout/PinScreenLayout";
import EnterPinContainer from "../../containers/EnterPinContainer/EnterPinContainer";

export function EnterPinScreen() {
    return (
        <PinScreenLayout titleKey="PIN">
            <EnterPinContainer />
        </PinScreenLayout>
    );
}
